import React, { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router-dom';
import { apiURL } from "../constants/apiUrlConstants";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import { Dialog, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { clearSessionStorage } from '../services/httpservice';
const style = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#A9A9A9',
  borderRadius: '50%',
  padding: "12px",
  position: 'absolute',
  top: '55px',
  boxSizing: 'border-box',
  fontSize: "45px",
  left: '41%',

};
const IdleTimerContainer = () => {

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false)
    handleLogout()
  };

  const [isIdle, setIsIdle] = useState(false);
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      const accessToken = sessionStorage.getItem('accessToken');
      if (!accessToken) {
        return;
      }
      clearSessionStorage();
      navigate('/');
    } catch (error) {
      clearSessionStorage();
      navigate('/');
      console.error('Error during logout:', error);
    }
  }

  const { reset, pause, resume } = useIdleTimer({
    timeout: 15 * 60 * 1000,
    onIdle: () => {
      handleOpen()
    },
    onActive: () => {
      reset()
      setIsIdle(false)
    },
  });

  return (
    <div>
      <Box  >
        <Dialog
          open={open}
          maxWidth="xs"
          fullWidth
          sx={{ borderRadius: "70px" }}>
          <DialogContent sx={{ backgroundColor: '#2A92BD', padding: '50px' }}>
            <DialogContent
              className='logoutIcon'
              sx={style}
            >
              <RestoreOutlinedIcon style={{ color: '#FFFFFF' }} />
            </DialogContent>
          </DialogContent>
          <DialogContent>
            <DialogContentText sx={{ color: '#2A92BD', textAlign: "center", fontWeight: 'bold', fontSize: '24px', mt: 5 }}>
              Session Expired
            </DialogContentText>
            <DialogContentText sx={{ color: '#2A92BD', textAlign: "center", fontWeight: 'normal', fontSize: '20px', mb: 2 }}>
              You have been logged out
            </DialogContentText>
            <DialogActions sx={{ justifyContent: "center" }}>
              <Button
                size="large"
                sx={{
                  py: 1,
                  height: '50px',
                  width: '15vw',
                  color: "#ffffff",
                  backgroundColor: "#2A92BD",
                  fontWeight: 'bold',
                  boxShadow: 0,
                  "&:hover": {
                    backgroundColor: "#00365C",
                    boxShadow: "none",
                  },
                }}

                variant="contained"
                onClick={handleClose}>
                Login
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </Box>
    </div>
  )
}

export default IdleTimerContainer